import * as React from 'react';
import { translate } from 'react-i18next';
import HomeCenterFeatures from "../components/HomeCenterFeatures";
import HomeFooterMenus from "../components/HomeFooterMenus";
import HomeTopSlides from "../components/HomeTopSlides";

class Home extends React.Component<any, any> {


	componentDidMount() {
		document.title = 'Cộng Cà Phê';
	}


	render() {
		return (
            <div className="website-c">
                <HomeTopSlides/>
                <div className="main">
                    <div className="container">
                        <HomeCenterFeatures/>
                        <HomeFooterMenus/>
                    </div>
                </div>
            </div>
		);
	}
}

export default translate('translations')(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.tsx